import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/layout"
import getLayout from "../../get-layout-util"

export const query = graphql`
  query PageQuery($id: String!) {
    wpPage(id: { eq: $id }) {
      id
      isFrontPage
      title
      content
      uri
      slug
      parentId
      seo {
        canonical
        title
        focuskw
        metaDesc
        metaKeywords
        metaRobotsNofollow
        metaRobotsNoindex
        opengraphAuthor
        opengraphDescription
        opengraphModifiedTime
        opengraphImage {
          altText
          sourceUrl
          title
        }
        opengraphPublishedTime
        opengraphPublisher
        opengraphSiteName
        opengraphTitle
        opengraphType
        opengraphUrl
        twitterDescription
        twitterTitle
        twitterImage {
          altText
          sourceUrl
          title
        }
      }
      pageBuilder {
        layouts {
          __typename
          ... on WpPage_Pagebuilder_Layouts_HeroHome {
            ...HeroHome
          }
          ... on WpPage_Pagebuilder_Layouts_Hero {
            ...Hero
          }
          ... on WpPage_Pagebuilder_Layouts_TextBlocks {
            ...TextBlocks
          }
          ... on WpPage_Pagebuilder_Layouts_FoodCards {
            ...FoodCards
          }
          ... on WpPage_Pagebuilder_Layouts_Gallery {
            ...Gallery
          }
          ... on WpPage_Pagebuilder_Layouts_ShopCards {
            ...ShopCards
          }
          ... on WpPage_Pagebuilder_Layouts_Catering {
            ...Catering
          }
          ... on WpPage_Pagebuilder_Layouts_Pdf {
            ...Pdf
          }
          ... on WpPage_Pagebuilder_Layouts_TheBuzzBlogPosts {
            ...TheBuzzBlogPosts
          }
          ... on WpPage_Pagebuilder_Layouts_MiscContent {
            ...MiscContent
          }
          ... on WpPage_Pagebuilder_Layouts_MenuItemsLayout {
            ...MenuItemsLayout
          }
          ... on WpPage_Pagebuilder_Layouts_JoinTheTeamForm {
            ...JoinTheTeamForm
          }
        }
        pageConfiguration {
          hideFooter
          hideHeaderItems
        }
      }
    }
  }
`

const PageTemplate = ({ data }) => {
  const { seo, slug, pageBuilder, title } = data.wpPage
  const layouts = pageBuilder.layouts || []
  return (
    <Layout
      {...pageBuilder.pageConfiguration}
      seo={seo}
      slug={slug}
      pageTitle={title}
    >
      {layouts.map(layout => getLayout(layout, slug))}
    </Layout>
  )
}

export default PageTemplate
//
// module.exports = imports => {
//   return `
// // This is a temporary generated file. Changes to this file will be overwritten eventually!
// import React from "react"
// import Layout from "../src/components/layout"
// // Sections
// ${imports
//   .map(
//     ({ componentName, filePath }) =>
//       `import ${componentName} from '${filePath}';`
//   )
//   .join("\n")}
//
// const Page = ({ pageContext }) => {
//   const {
//     page: { seo, slug, pageBuilder, title, parentId },
//   } = pageContext
//   const layouts = pageBuilder.layouts || []
//   return (
//     <Layout {...pageBuilder.pageConfiguration} seo={seo} slug={slug}>
//       {
//         layouts.map((layout, index) => {
//           ${imports
//             .map(({ componentName, layoutType }) => {
//               return `
//               if (layout.fieldGroupName === '${layoutType}') {
//                   return <${componentName}
//                   {...layout}
//                       pageTitle={title}
//                       parentId={parentId}
//                       slug={slug}
//                       key={layout.fieldGroupName + index}
//                   />;
//               }
//             `
//             })
//             .join("\n")}
//         })
//       }
//     </Layout>
//   )
// }
// export default Page
//   `
// }
